const BASE = (process.env.REACT_APP_API_URL || '') + '/api';

export function clearSession() { localStorage.removeItem('ri_user'); localStorage.removeItem('ri_rol'); localStorage.removeItem('ri_loggedin'); }

async function req(method, path, body) {
  const opts = {
    method,
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
  };
  if (body !== undefined) opts.body = JSON.stringify(body);
  const r = await fetch(`${BASE}${path}`, opts);
  if (r.status === 401) {
    clearSession();
    window.location.reload();
    throw new Error('Sesión expirada');
  }
  if (!r.ok) {
    const err = await r.json().catch(() => ({ error: r.statusText }));
    throw new Error(err.error || r.statusText);
  }
  return r.json();
}

export const api = {
  login:    (u, p)      => req('POST', '/login', { username:u, password:p }),
  logout:   ()           => req('POST', '/logout'),
  cambiarPw:(actual, nueva) => req('POST', '/cambiar-password', { actual, nueva }),

  getConfig:  ()        => req('GET',  '/config'),
  saveConfig: (cfg)     => req('PUT',  '/config', cfg),

  getAll:   (col)           => req('GET',    `/${col}`),
  create:   (col, item)     => req('POST',   `/${col}`, item),
  update:   (col, id, item) => req('PUT',    `/${col}/${id}`, item),
  remove:   (col, id)       => req('DELETE', `/${col}/${id}`),

  backup:   () => fetch(`${BASE}/backup`, { credentials:'same-origin' }).then(r => r.blob()),
  restore:  (data) => req('POST', '/restore', data),
};

export default api;
